import { HttpService } from './http';
import { ApiResponse } from '../models';

/**
 * General Service
 */

class GeneralService {
  public constructor(private readonly http: HttpService) {}

  public builderApi = (
    methodUrl: string,
    method: 'POST' | 'GET' | 'PUT',
    data?: any
  ) =>
    this.http.request<{ data: any }>({
      url: methodUrl,
      method: method,
      data: data || {}
    });
}

export { GeneralService };
